'use client'

import styled from 'styled-components'

import { groupProductCharacteristics } from '../../../entities/marketItem/model/product-characteristics'
import type { GetProductInfoResponse } from '../../api/generated'
import { colors } from '../../constants/colors'

export function ProductCharacteristics({
  product,
}: {
  product: Pick<GetProductInfoResponse, 'stringCriteria' | 'numberCriteria'>
}) {
  const groups = groupProductCharacteristics(product)
  if (!groups.length) return null

  return (
    <Section aria-label="Характеристики">
      <Title>Характеристики</Title>
      <Groups>
        {groups.map(group => (
          <div key={group.name}>
            {group.name && <GroupTitle>{group.name}</GroupTitle>}
            <List>
              {group.rows.map(row => (
                <Row key={row.key}>
                  <Name>{row.title}</Name>
                  <Value>{row.values.join(', ')}</Value>
                </Row>
              ))}
            </List>
          </div>
        ))}
      </Groups>
    </Section>
  )
}

const Section = styled.section`
  width: 100%;
  margin-top: 32px;
`
const Title = styled.h2`
  margin: 0 0 8px;
  text-align: left;
`
const Groups = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 18px 20px;
  border-radius: 10px;
  background: #f8f8fa;
`
const GroupTitle = styled.h3`
  margin: 0 0 8px;
  font-size: 16px;
  color: ${colors.black};
  overflow-wrap: anywhere;
`
const List = styled.dl`
  margin: 0;
`
const Row = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
  padding: 8px 0;
  border-bottom: 1px solid ${colors.lightGrey};
  &:last-child {
    border-bottom: 0;
  }
`
const Name = styled.dt`
  color: ${colors.black};
  overflow-wrap: anywhere;
`
const Value = styled.dd`
  margin: 0;
  color: ${colors.primary};
  font-weight: 600;
  text-align: right;
  overflow-wrap: anywhere;
`
